// import React from 'react';
// import './ukg_services_hero.css';
// import vynlogo from '../../img/des_sec/vyn_content.svg'; // Adjust the path as necessary

// const PartnerVynHeader = () => {
//   return (
//     <section className="hero-container-pvh">
//       <div className="hero-content-pvh">
       
        
//         <h1 className="hero-title-pvh">
//           <span className='hero-title-pvh2'></span> <span className="highlight-text-pvh">Delivering Excellence as a UKG Certified Partner</span>
//         </h1>
        
//         <p className="hero-description-pvh">
//         We provide UKG-certified workforce solutions that streamline operations, ensure compliance, and enhance performance, delivering exceptional value through our strategic partnership with UKG.
//         </p>
//       </div>
      
//       {/* <div className="wave-bottom-pvh"></div> */}
//     </section>
//   );
// };

// export default PartnerVynHeader;

import React from 'react';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';
import './partner_vyn_header.css';
import vynlogo from '../../img/des_sec/vyn_content.svg'; // Adjust the path as necessary

const PartnerVynHeader = () => {
  const [ref, inView] = useInView({
    triggerOnce: false, // animation repeats on re-entry
    threshold: 0.1,
  });

  const fadeIn = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(20px)',
    config: { duration: 800 },
  });

  const titleAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(-20px)',
    config: { duration: 1000 },
  });

  const textAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(10px)',
    config: { duration: 1000 },
  });

  return (
    <section className="hero-container-pvh" ref={ref}>
      <animated.div className="hero-content-pvh" style={fadeIn}>
        <animated.h1 className="hero-title-pvh" style={titleAnimation}>
          <span className='hero-title-pvh2'></span> 
          <span className="highlight-text-pvh">Partner with VYN</span>
        </animated.h1>

        <animated.p className="hero-description-pvh" style={textAnimation}>
          Join hands with VYN to transform workforce management. Our partnership program empowers you with cutting-edge tools, streamlined processes, and mutual growth opportunities—helping you deliver unmatched value, innovation, and efficiency to your clients.
        </animated.p>
      </animated.div>
      {/* <div className="wave-bottom-pvh"></div> */}
    </section>
  );
};

export default PartnerVynHeader;
